import React from 'react';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import MuiLink from '@mui/material/Link';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import { ReactComponent as CopyIcon } from 'assets/svg/copy_icon.svg';
import Tooltip from '@mui/material/Tooltip';
import { snack } from 'utils/toast';
import CopyToClipboard from 'react-copy-to-clipboard';
import TextField from 'components/form/TextInput';
import IconButton from 'components/IconButton';
import { EmailIcon, MobileIcon } from 'components/icons';
import { updateMessage } from 'store/modules/messages/actions';

const ShareVideoModal = ({ videoUrl, onClose }) => {
  const dispatch = useDispatch();

  const onShare = (type) => () => {
    dispatch(
      updateMessage({
        type,
        message:
          'Hi there {FIRST_NAME}, check out our new page!' + '\n' + videoUrl,
      }),
    );
  };

  return (
    <Dialog open fullWidth maxWidth="sm">
      <DialogContent>
        <Box display="flex" justifyContent="flex-end">
          <IconButton
            className="close"
            onClick={onClose}
            icon={<CloseIcon />}
          />
        </Box>
        <Typography paragraph textAlign="center" fontWeight={600} variant="h2">
          Your Page is now live!
        </Typography>
        <Paper
          elevation={0}
          sx={{ bgcolor: 'background.default', p: 3, mb: 2 }}
        >
          <Typography textAlign="center" variant="subtitle1" fontWeight={600}>
            Visit your page
          </Typography>
          <TextField
            disabled
            fullWidth
            value={videoUrl}
            endAdornment={
              <CopyToClipboard
                text={videoUrl}
                onCopy={() => snack.success('Link copied!')}
              >
                <Tooltip title="Copy URL">
                  <IconButton icon={<CopyIcon />} />
                </Tooltip>
              </CopyToClipboard>
            }
          />
        </Paper>
        <Paper
          elevation={0}
          sx={{ bgcolor: 'background.default', p: 3, mb: 2 }}
        >
          <Typography
            paragraph
            textAlign="center"
            variant="subtitle1"
            fontWeight={600}
          >
            Share your page
          </Typography>
          <Stack direction="row" spacing={3}>
            <MuiLink
              onClick={onShare('email')}
              component={Link}
              to={`/messages/create`}
              sx={{ flex: 1 }}
            >
              <Paper elevation={0} sx={{ p: 3, textAlign: 'center' }}>
                <EmailIcon sx={{ fontSize: 30 }} />
                <Typography variant="subtitle1" fontWeight={600}>
                  Share by <br />
                  Email
                </Typography>
              </Paper>
            </MuiLink>
            <MuiLink
              onClick={onShare('sms')}
              component={Link}
              to={`/messages/create`}
              sx={{ flex: 1 }}
            >
              <Paper elevation={0} sx={{ p: 3, textAlign: 'center' }}>
                <MobileIcon sx={{ fontSize: 30 }} />
                <Typography variant="subtitle1" fontWeight={600}>
                  Share by <br />
                  Text Message
                </Typography>
              </Paper>
            </MuiLink>
          </Stack>
        </Paper>
        <Box textAlign="center">
          <MuiLink component={Link} to="/pages">
            Return to Pages
          </MuiLink>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default ShareVideoModal;
